import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'KaikeiKijunSettingTitle',
  props: {
  mainTitle: String
},
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", null, "附属明細表（医療法人会計基準）  " + _toDisplayString(__props.mainTitle), 1))
}
}

})